// chatbot errors

export const errorOnInvalidMessageInput = () => {
  alert("Invalid message input")
}

export const errorOnGetChatBotResponse = () => {
  alert("Error getting chatbot response")
}